import { render, staticRenderFns } from "./ListaDocumentos.vue?vue&type=template&id=92c3924a&scoped=true&"
import script from "./ListaDocumentos.vue?vue&type=script&lang=js&"
export * from "./ListaDocumentos.vue?vue&type=script&lang=js&"
import style0 from "./ListaDocumentos.vue?vue&type=style&index=0&id=92c3924a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92c3924a",
  null
  
)

export default component.exports